import React from 'react'
import {TransformWrapper, TransformComponent, useControls} from 'react-zoom-pan-pinch'

const Controls = () => {
  const {zoomIn, zoomOut, resetTransform} = useControls()

  return (
    <div className='tools'>
      <button onClick={() => zoomIn()}>+</button>
      <button onClick={() => zoomOut()}>-</button>
      <button onClick={() => resetTransform()}>x</button>
    </div>
  )
}
const PinchZoomPan = ({min, initialZoom, max = 1, className, style, children}) => {
  // console.log('### PinchZoomPan', {min, initialZoom})
  return (
    <div className={className} style={{...style}}>
      <TransformWrapper
        initialScale={initialZoom}
        minScale={min}
        maxScale={max}
        limitToBounds={false} // Жесткие границы
        centerOnInit={true} // Центрирование при инициализации
        wheel={{step: 0.3}} // Плавный зум
        doubleClick={{disabled: true}} // Отключить двойной клик (опционально)
      >
        <TransformComponent
          wrapperStyle={{
            width: '100%',
            height: '100%',
            overflow: 'hidden',
          }}
          contentStyle={{
            width: 'fit-content', // Подстраивается под контент
            height: 'fit-content',
          }}
        >
          {children}
        </TransformComponent>
      </TransformWrapper>
    </div>
  )
}

export default React.memo(PinchZoomPan)
